import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { client } from "../../utils/api";
import Layout from "../Layout/Layout";
import BlogHeaderDetail from "./components/BlogHeaderDetail";
import { getCssVariable } from "src/utils/utils";
import { BlogDetailContent } from "./components/BlogDetailContent";

const BlogDetail = () => {
  const gqlClient = client;
  const { slug } = useParams();
  const primaryColor = getCssVariable("--primary-color");

  const [blogDetailHeaderData, setBlogDetailHeaderData] = useState<{
    tagTitle: string;
    title: string;
    blogDetailMainImage: string;
    blogDetailVideoFile: string;
    description: string;
    date: string;
    socialMediaLinks: any;
    author: {
      image: {
        url: string;
      };
      name: string;
    };

  } | null>(null);
  const [blogDetailContentData, setBlogDetailContentData] = useState<any>();
  const [blogDetailMainImage, setBlogDetailMainImage] = useState<any>();
  const [blogDetaiGetAuthors, setBlogDetaiGetAuthors] = useState<any>();
  const [blogDetailLinks, setBlogDetailLinks] = useState<any>();
  const [listComponents, setListComponents] = useState<any[]>([]);
  const [aiContent, setAiContent] = useState<any>();

  const [loading, setLoading] = useState(true);
  const [seoData, setSeoData] = useState<any>();

  const fetchHomePageListComponents = async (skip: number) => {
    return await gqlClient.GetHomePageListComponents({
      componentsLimit: 5,
      skip,
      articleListLimit: 4,
      internalName: 'Home',
    });
  };

  useEffect(() => {
    // Fetch all the data for homepage components
    const fetchBlogDeatailsPageData = async () => {
      setLoading(true);
      try {
        const [blogDetailPageResponse, listComponentsResponse] = await Promise.all([
          gqlClient.GetBlogDetailPage({
            slug: slug ?? "",
          }),
          fetchHomePageListComponents(0)
        ]);
        setAiContent(blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog?.aiContent)
        // Set blog detail data
        setBlogDetailHeaderData({
          tagTitle:
            blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
              ?.eyebrowText ?? "",
          title:
            blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
              ?.title ?? "",
          description:
            blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
              ?.subDescription ?? "",
          date:
            blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
              ?.publicationDate ?? "",
          socialMediaLinks:
            blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
              ?.socialMediaLinksCollection?.items ?? [],
          author: {
            image: {
              url:
                blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]
                  ?.blog?.author?.image?.url ?? "",
            },
            name:
              blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]
                ?.blog?.author?.name ?? "",
          },
          blogDetailMainImage:
            blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
              ?.thumbnailImage?.url ?? "",

          blogDetailVideoFile:
            blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
              ?.videoFile?.url ?? "",

        });

        setBlogDetailContentData(
          blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
            ?.articledescriptionJson?.json
        );
        setBlogDetailMainImage(
          blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
            ?.mainImage?.url
        );
        setBlogDetaiGetAuthors(
          blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
            ?.author
        );
        setSeoData(
          blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]
            ?.seoFields
        );
        setBlogDetailLinks(
          blogDetailPageResponse.pageBlogDetailPageCollection?.items[0]?.blog
            ?.linkList
        );

        // Filter and set only ArticleList components
        const allComponents = listComponentsResponse?.pageGenericCollection?.items[0]?.componentsCollection?.items || [];
        const articleListComponents = allComponents.filter(
          (component: any) => component.__typename === "ArticleList"
        );
        setListComponents(articleListComponents);

        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching blog details page data:", error);
      }
    };

    fetchBlogDeatailsPageData();
  }, []);

  return (
    <Layout
      style={{ color: "#fff" }}

      hamburgerStyle={{
        backgroundColor: primaryColor,
      }}
      saleClassName={"btn-gradient-bdr"}
      headerStyle={{ position: "relative" }}
      loading={loading}
      seoData={seoData}
    >
      <>
        {blogDetailHeaderData && (
          <BlogHeaderDetail content={blogDetailHeaderData} />
        )}

        {blogDetailContentData && (
          <BlogDetailContent
            content={blogDetailContentData.content}
            mainImage={blogDetailMainImage}
            authors={blogDetaiGetAuthors}
            linkListCollection={blogDetailLinks?.linkListCollection}
            listComponents={listComponents}
            aiContent={aiContent}
          />
        )}
      </>
    </Layout>
  );
};

export default BlogDetail;